import React, { useState, useEffect } from 'react';

import { apiPatch, getBenefitsApiUrl, apiMessages } from '../common/AppApi';
import Processing from '../common/Processing';
import { PanStatusArray, PanTypeArray, PageSize } from '../common/Constants';
import { formatPhone, decodeValues } from '../common/Formats';
import Strings from  '../common/Strings';
import Pagination, { resetPaging } from '../common/Pagination';
import { prepareDownloadUrl } from '../common/CommonUtils';

import ConfirmDialog, { closeConfirmDialog, showConfirmDialog } from '../common/ConfirmDialog';

export default function DisplayPans(props) {
	let [showSpinner, setSpinner] = useState(false);
	let setMessage = props.setMessage;

	let pans = props.pans;
	let pagingData = props.pagingData;
	let setPagingData = props.setPagingData;

	let confirmSettingsDefaults = {
		button:"Inactivate",type:"danger",body:"Inactivate this pan?"
	};
	let [confirmSettings, setConfirmSettings] = useState(confirmSettingsDefaults);
	let confirmStatusChange = (panId, panStatusId, pan) => {
		let confirmFunc = () => doStatusChange(panId, panStatusId);
		if (panStatusId == 1) {
			setConfirmSettings({button:"Lost",type:"danger",body:"Status this pan as Lost?".replace("this pan", pan),
				confirm:confirmFunc});
		} else if (panStatusId == 2){
			setConfirmSettings({button:"Stolen",type:"danger",body:"Status this pan as Stolen?".replace("this pan", pan),
				confirm:confirmFunc});
		} else {
			setConfirmSettings({button:"Inactive",type:"danger",body:"Status this pan as Inactive?".replace("this pan", pan),
				confirm:confirmFunc});
		}
		showConfirmDialog();
	};

	let doStatusChange = (panId, panStatusId) => {
		closeConfirmDialog();

		setSpinner(true);

		let body = {
			panStatusId:panStatusId
		};

		let url = getBenefitsApiUrl() + '/pans/' + panId;
		apiPatch(url, body).then((resp)=> {
			setMessage({text:'The pan has been statused.'});
			props.statusSuccess();

		}).catch( (err) => {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 404){
				messageObject.text = apiMessages(err);
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	let DisplayPan = (props) => {
		let fileDownload = prepareDownloadUrl(getBenefitsApiUrl() + '/pan/' + props.pan.panId + '/qrcode/pdf');
		let clickId = 'pan-print-' + props.pan.panId;

		return (
			<tr>
			<td>{props.pan.pan}</td>
			<td>{props.pan.activeDate}</td>
			<td>{props.pan.expirationDate}</td>
			<td>{decodeValues(props.pan.panStatusId, PanStatusArray)}</td>
			<td>{decodeValues(props.pan.panTypeId, PanTypeArray)}</td>
			<td>
				<button type="button" className="btn btn-danger btn-sm" onClick={() => confirmStatusChange(props.pan.panId, 4, props.pan.pan)}>Inactivate</button>
				&nbsp;<button type="button" className="btn btn-danger btn-sm" onClick={() => confirmStatusChange(props.pan.panId, 1, props.pan.pan)}>Lost</button>
				&nbsp;<button type="button" className="btn btn-danger btn-sm" onClick={() => confirmStatusChange(props.pan.panId, 2, props.pan.pan)}>Stolen</button>
				&nbsp;<a className="btn btn-primary btn-sm" href={fileDownload} id={clickId}>QR Code <i className="fa fa-file-pdf-o" aria-hidden="true"></i></a>
			</td>
			</tr>
		);
	};

	let DisplayPansBody = pans.map( (data, index) => {
		return ( (index >= pagingData.beginIndex) && (index < (pagingData.beginIndex + PageSize)) ) ? <DisplayPan key={index} pan={data} /> : null;
	});

	let PanTable = () => {
		if(pans && pans.length)
			return (
				<>
				<div>{pans.length} PANs </div>
				<table className="table table-hover" id="panTable">
					<thead>
						<tr>
							<th>Pan</th>
							<th>Active Date</th>
							<th>Expiration Date</th>
							<th>Status</th>
							<th>Type</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{DisplayPansBody}
					</tbody>
				</table>

				<Pagination recordCount={pans.length} pagingData={pagingData} setPagingData={setPagingData} pageSize={PageSize} />

				</>
		);
		return null;
	};

	return <>
		<Processing show={showSpinner}/>
		<PanTable />
		<ConfirmDialog settings={confirmSettings} />
	</>;
}